export default __webpack_public_path__ + "00e0e6ec4ed55b713c33fae7adbae058.svg";